<template>
  <v-container >
    <v-row class="print-hide">
      <v-col cols="12">
        <v-row class="d-flex print-hide align-center">
          <v-breadcrumbs :items="breadcrumbs"> </v-breadcrumbs>
          <v-spacer></v-spacer>
          <div class="mx-auto px-6">
            {{ $todayDate() }}
          </div>
        </v-row>
      </v-col>
      <v-col cols="12">
        <v-alert
            class="mx-3"
            color="primary"
            icon="mdi-information"
            border="left"
            elevation="0"
            text
        >Izvještaj se generira nakon što su sve ocjene zaključene za sve učenike
        </v-alert>
      </v-col>
    </v-row>
    <v-row class="print-show bel">
      <div style="display: flex; width: 100%;">
        <div><img class="print-show" width="100%" src="@/assets/img/plans_footer.png"/></div>
      </div>
    </v-row>
    <row class="print-show title">
      <h5 class="primary--text">Uspjeh učenika iz nastavnih predmeta - {{ selected_department ? selected_department.label : '' }}</h5>
    </row>
    <row class="print-show title"></row>
<!--    <v-row>-->
<!--      <v-col cols="12">-->
<!--        <v-tabs fixed-tabs v-model="tab" class="print-hide">-->
<!--          <v-tab v-for="item in tabs" :key="item.tab">-->
<!--            {{ item.tab }}-->
<!--          </v-tab>-->
<!--        </v-tabs>-->
<!--        <v-divider class="mx-4 print-hide"></v-divider>-->
<!--      </v-col>-->
<!--    </v-row>-->
<!--    <v-row>-->
<!--      <v-col>-->
<!--        <v-tabs-items v-model="tab">-->
<!--          <v-tab-item v-for="item in tabs" :key="item.tab">-->
<!--            <component-->
<!--                    v-bind:is="item.content"-->
<!--                    :semester="item.semester"-->
<!--            ></component>-->
<!--          </v-tab-item>-->
<!--        </v-tabs-items>-->
<!--      </v-col>-->
<!--    </v-row>-->

    <v-row>
      <v-col cols="12" md="3">
        <v-select
            outlined
            v-model="selected_field"
            :items="school.educational_fields"
            item-text="name"
            return-object
            color="primary"
            label="Odabir zanimanja"
            hide-details
            dense
            class="mx-3 my-3 print-hide"
            @change="pickedFields"
            v-if="$checkPermission('profession picker')"

        ></v-select>
      </v-col>
      <v-col cols="12" md="3">
        <v-select
            outlined
            v-model="selected_year"
            :items="getYears"
            item-text="text"
            return-object
            color="primary"
            label="Odabir razreda"
            hide-details
            dense
            @change="pickedYear"
            class="mx-3 my-3 print-hide"
            v-if="$checkPermission('class_year picker')"
        ></v-select>
      </v-col>
      <!--      razrednik-->
      <v-col cols="12" md="3" v-if="isHeadroomTeacher">
        <v-select
            outlined
            v-model="selected_department"
            :items="headroomDepartments"
            item-value="id"
            item-text="label"
            return-object
            color="primary"
            label="Odabir odjeljenja"
            hide-details
            dense
            class="mx-3 my-3 print-hide"
            @change="getDataFromApi"
            v-if="$checkPermission('department picker')"

        ></v-select>
      </v-col>
      <v-col cols="12" md="3" v-else>
        <v-select
            outlined
            v-model="selected_department"
            :items="items_department"
            item-value="id"
            item-text="label"
            return-object
            color="primary"
            label="Odabir odjeljenja"
            hide-details
            dense
            class="mx-3 my-3 print-hide"
            @change="getDataFromApi"
            v-if="$checkPermission('department picker')"

        ></v-select>
      </v-col>
      <v-col cols="12" md="3">
        <v-select
            outlined
            :items="semesters"
            v-model="semesterNumber"
            item-text="label"
            item-value="value"
            hide-details
            dense
            class="my-3 mx-3 print-hide"
            @change="getDataFromApi"
            label="Polugodište"
        ></v-select>
      </v-col>
      <v-col cols="12" md="1" class="print-hide text-right ma-3 float-right">
        <v-btn  width="170" @click="print()" class="text-none" outlined color="primary">
          <v-icon left>mdi-printer</v-icon>
          Ispišite izvještaj
        </v-btn>
      </v-col>
    </v-row>
    <v-row class="mx-0">
      <v-col cols="12" md="12">
        <v-data-table
            :headers="headers"
            :items="data"
            class="elevation-1 data_table3"
            hide-default-footer
            items-per-page=30
        ></v-data-table>
      </v-col>
    </v-row>
    <v-row class="print-show" >
      <v-col class="print-show description">
        <span>5 - odličnih, 4 - vrlo dobrih, 3 - dobrih, 2 - dovoljnih, 1 - nedovoljnih, N - neocjenjenih, P - prosječna ocjena</span>
      </v-col>
    </v-row>
    <v-row>
      <div class="print-show" >
        <v-row class="print-show" >
          <v-col class="print-show bottom-footer">
            <span>Centar za informacijske tehnologije Sveučilišta u Mostaru, SUMIT <br> A: Trg hrvatskih velikana 1, 88000 Mostar, BiH | E: sumit@sum.ba | W: https://sumit.sum.ba</span>
          </v-col>
        </v-row>

      </div>
    </v-row>
    <row class="print-show bottom-footer1">
      <v-col class="print-show bottom-footer1">
        <span>Izvještaj je ispisan iz SUMIT eMatice: {{ $todayDate()  }} {{timestamp}} </span>
      </v-col>
    </row>
  </v-container>
</template>

<script>

import ApiV2 from "@/services/ApiV2";
  // import Semester from "./Semester";

  export default {
    name: "odjeljenje",
    components: {
      // Semester
    },
    computed: {
      currentSchool() {
        return this.$store.getters.getSchool;
      },
      schoolId() {
        return this.$store.getters.getSchoolFieldId;
      },
      // getDepartment() {
      //   return this.$store.getters.getGlobalDepartment;
      // },

      school() {
        return this.$store.getters.getSchool;
      },
      currentRole() {
        return this.$store.getters.getCurrentRole;
      },
      headroomDepartments() {
        return this.$store.getters.getCurrentRole?.schools.filter(x=>x.value == localStorage.getItem('school_id'))[0]?.headroom_departments;
      },
      isHeadroomTeacher() {
        return this.currentRole.role_id === 5;
      },
      selectedField() {
        return this.$store.getters.getSchoolFieldId;
      },
      getYears() {
        let children = [];

        if (this.$store.getters.getSchool.type === "Osnovna škola") {
          children = [
            {
              text: "1. razred",
              value: 1,
            },
            {
              text: "2. razred",
              value: 2,
            },
            {
              text: "3. razred",
              value: 3,
            },
            {
              text: "4. razred",
              value: 4,
            },
            {
              text: "5. razred",
              value: 5,
            },
            {
              text: "6. razred",
              value: 6,
            },
            {
              text: "7. razred",
              value: 7,
            },
            {
              text: "8. razred",
              value: 8,
            },
            {
              text: "9. razred",
              value: 9,
            },
          ];
        } else {
          children = [
            {
              text: "1. razred",
              value: 11,
            },
            {
              text: "2. razred",
              value: 12,
            },
            {
              text: "3. razred",
              value: 13,
            },
            {
              text: "4. razred",
              value: 14,
            },
          ];
        }
        return children;
      },

      breadcrumbs() {
        return [
          {
            text: "Uspjeh učenika iz nastavnih predmeta",
            disabled: true,
            href: "/admin/izvjestaj/ostvarenje_plana",
          },
        ];
      },

    },

    data() {
      return {
        department: {},
        loading: true,
        tab: null,
        tabs: [
          { tab: "I. POLUGODIŠTE", content: "Semester", semester: 1 },
          { tab: "II. POLUGODIŠTE", content: "Semester", semester: 2 },
          {
            tab: "KRAJ ŠKOLSKE GODINE",
            content: "Semester",
            semester: 0
          }
        ],
        selected_field:null,
        selected_department: null,
        selected_year: null,
        school_class:null,
        items_department: [],
        activeRole: {
          model: -1,
          show: true,
          forceShow: false,
          data: [],
        },
        activeSchool: {
          model: {},
          label: "",
          data: [],
          show: true,
        },
        headers: [
          {
            text: "NASTAVNI PREDMETI",
            align: "left",
            sortable: false,
            value: "subject_name",
          },
          // { text: "planirano", value: "planirano" },
          // { text: "ostvareno", value: "ostvareno" },
          // { text: "dopunske", value: "dopunske" },
          // { text: "dodatne", value: "dodatne" },
          { text: "5", value: "odlican", align: "left" },
          { text: "4", value: "vrlodobar", align: "left" },
          { text: "3", value: "dobar", align: "left" },
          { text: "2", value: "dovoljan", align: "left" },
          { text: "1", value: "nedovoljan", align: "left" },
          { text: "N", value: "neocijenjen", align: "left" },
          { text: "P", value: "prosjecna_ocjena", align: "left" },
          // { text: "SVEGA", value: "ukupno" },
        ],
        data: [],
        semesterNumber: 1,
        semesters: [
          {
            label: '1. polugodište',
            value: 1
          },
          {
            label: '2. polugodište',
            value: 2
          },
          {
            label: 'Kraj školske godine',
            value: 0
          },
        ]
      };
    },

    methods: {
      async getDepartments() {
        let params = {
          filterRelation: {
            schoolEducationalField: {
              id: this.selected_field?.pivot.id,
            },
          },
          filter: {
            school_class: this.selected_year?.value,
          },
        };

        await ApiV2.get(`departments`, {
          params: params,
        }).then((response) => {
          this.items_department = response.data.data;
        });
      },
      pickedFields() {
        this.getDepartments();
      },
      pickedYear() {
        this.getDepartments();
      },
      print() {
        window.print();
      },
      async getDataFromApi(){
        let {data} = await ApiV2.post('reports/get_subjects_average_grade', {
          department_id: this.selected_department.id,
          semester: this.semesterNumber,
        });
        this.data = data;
      }
    }
  };
</script>

<style>
  .v-slide-group__prev--disabled {
    display: none !important;
  }
</style>
